import spinner from '../utils/rbata.spinner';
import logger from '../utils/rbata.logger';
import cartCounter from '../cart/rbata.cart-counter';
import cartTracking from '../tracking/rbata.tracking.cart';
import consumerEvents from '../tracking/rbata.consumer-events';
import detailPanel from '../pdp/rbata.detailpanel';
import miniCart from '../cart/rbata.miniCart';

/**
 *  Executes add to cart and returns request object to handle after flow if needed
 * @param url
 * @param productCode
 * @param clearErrorsFn
 * @param renderErrorsFn
 * @returns {*}
 */
const addToCartService = {
    addToCart(url, productCode, clearErrorsFn, renderErrorsFn, giftCard = {giftCard: false}, reload = false) {
        const data = !giftCard.isGiftcard ?
                {qty: 1, productCode: productCode} :
                {qty: 1, productCode: productCode, individualGiftCardValue: giftCard.amount, giftCardMessage: giftCard.message};

        const request = $.ajax({
            url:         url,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify(data)
        });

        spinner.visibility(true);

        request.done(response => {
            if (clearErrorsFn && typeof (clearErrorsFn) === typeof (Function)) {
                clearErrorsFn();
            }
            if (response.success === true) {
                //track GTM dataLayer
                cartTracking.addToCart(response.trackingProductData, 1)
                //track consumer event
                consumerEvents.trackAddToCartEvent(response.trackingProductData);
                if (reload) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 10);
                } else {
                    cartCounter.updateCounter(response.cartData.totalUnitCount);
                    detailPanel.clearGiftCardMessage();
                    miniCart.showMiniCart();
                }
            } else {
                renderErrorsFn(response.errors.length ? response.errors : response.globalErrors);
            }
        });
        request.fail(jqXHR => {
            logger.error(`${jqXHR.status} error in addToCartService.addToCart`);
            if (jqXHR.status === 405 || jqXHR.status === 500) {
                window.location.reload();
            }
        });
        request.always(() => {
            spinner.visibility(false);
        });
        return request;
    },
};

export default addToCartService;
